import React from "react";
import { instantSave } from "../../helpers.js";

import styles from "./Select.scss";

export default class Select extends React.Component {
  state = { value: this.props.value };

  handleChange = (event) => {
    this.setState({ value: event.target.value });

    setTimeout(() => {
      instantSave();
    }, 20);
  };

  render() {
    return (
      <div className="record-field record-field-date">
        <label htmlFor="projectDisplayWeightSelectBox">Display weight</label>

        <div className={styles.selectWrap}>
          <select
            id="projectDisplayWeightSelectBox"
            className={styles.select}
            value={this.state.value}
            onChange={this.handleChange}
          >
            <option value="-1">
              Pin to the top of the parent project listings page
            </option>
            <option value=""> </option>
            <option value="1">
              Pin to the bottom of the parent project listings page
            </option>
          </select>
        </div>

        <input
          type="hidden"
          name="project[display_weight]"
          value={this.state.value}
        />
      </div>
    );
  }
}
